import { Link, useNavigate } from "react-router-dom";
import { BASE_URL, SEARCH_PRODUCT_URL_LOCAL } from "../../../utility/BaseUrl";

const CategoryComponentChild = ({ item }) => {
  const { logo, logo_alt, logo_title, slug, title } = item.category;

  const queryParams = new URLSearchParams({ category: title }).toString();

  if (item.is_active)
    return (
      <div className="col-4 col-lg-2 p-0">
        <div style={{ minHeight: 192 }}>
          <Link
            to={SEARCH_PRODUCT_URL_LOCAL + `?${queryParams}`}
            className="category_item"
          >
            <img
              className="w-100"
              src={BASE_URL + logo}
              alt={logo_alt}
              title={logo_title}
            />
            <p className="text-center text-dark"> {title} </p>
          </Link>
        </div>
      </div>
    );
};

export default CategoryComponentChild;
